import { render, staticRenderFns } from "./wtCollapse.component.vue?vue&type=template&id=41d8fdb7&"
import script from "./wtCollapse.component.vue?vue&type=script&lang=js&"
export * from "./wtCollapse.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports